import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {isDefined} from '../../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {inboxHasColor} from '../../../../../helpers/modelHelpers';
import {buildConversationPublicId} from '../../../../../helpers/models/conversationHelpers';
import {useAppSelector} from '../../../../../helpers/reduxHelpers';
import {getInboxes} from '../../../../../store/data/inboxes/inboxesSelectors';
import {getSelectedConversation} from '../../../../../store/panels/analytics/details/analyticsPanelDetailsSelectors';
import {SidePanelSectionWrapper} from '../sidePanelSectionWrapper';
import {SummaryContacts} from './summaryContacts';
import {SummaryConversationId} from './summaryConversationId';
import {SummaryConversationInteractions} from './summaryConversationInteractions';
import {SummaryInboxes} from './summaryInboxes';

/*
 * Component.
 */

export const SummarySection: FC = () => {
  const theme = useUserTheme();
  const conversation = useAppSelector(getSelectedConversation);
  const inboxesResourceMap = useAppSelector(getInboxes);

  if (!conversation) {
    return null;
  }

  const inboxes = conversation.inboxIds
    .map((id) => {
      const inbox = inboxesResourceMap[id];
      if (!inbox) {
        return undefined;
      }

      const color = inboxHasColor(inbox) ? inbox.color : theme.greys.shade50;

      return {name: inbox.name, color};
    })
    .filter(isDefined);

  return (
    <SidePanelSectionWrapper
      sectionTitle={<Trans id="analytics-drawer-details-summary">Summary</Trans>}
      isCollapsible
    >
      <SummaryConversationInteractions conversation={conversation} />
      <SummaryInboxes inboxes={inboxes} />
      <SummaryContacts selectedConversation={conversation} />
      <SummaryConversationId conversationId={buildConversationPublicId(conversation)} />
    </SidePanelSectionWrapper>
  );
};
